import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Modal from 'react-responsive-modal';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Moment from 'moment';
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';
import { StatCardsGrid } from '../common/stat-cards';

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

function fmtMoney(val) {
    if (val === null || val === undefined || val === '') return '—';
    const num = parseFloat(val);
    if (isNaN(num)) return '—';
    return 'S/ ' + num.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Mismo criterio que /all-cash-user: GANANCIA CASH (comisión por compra) y
// AGREGAR CASH (bono/ajuste manual) son cash otorgado; COMPRA CON CASH es
// cash gastado en una compra.
const TIPO_COLORS = {
    'GANANCIA CASH': { bg: '#d4edda', color: '#155724' },
    'AGREGAR CASH': { bg: '#d4edda', color: '#155724' },
    'COMPRA CON CASH': { bg: '#f8d7da', color: '#721c24' },
};

function tipoBadge(tipo) {
    const s = TIPO_COLORS[tipo] || { bg: '#e2e3e5', color: '#383d41' };
    return (
        <span style={{ background: s.bg, color: s.color, borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>
            {tipo}
        </span>
    );
}

export class Ver_cash_user extends Component {
    constructor(props) {
        super(props);
        this.handleRegister = this.handleRegister.bind(this);
        this.onChangeMount = this.onChangeMount.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.state = {
            open: false,
            name: '',
            last_name: '',
            id: '',
            amount: 0,
            errors: {},
            loading: false,
            message: "",
            results: [],
            temp: [],
            filter: '',
            page: 1,
            // Más reciente primero por default -- para detectar fraude sirve
            // ver los movimientos más nuevos arriba sin tener que reordenar.
            sort: { key: 'Fecha', dir: 'desc' },
            current_credit: 0,
        };
    }

    onChangeMount(e) {
        this.setState({
            mount: e.target.value
        });
      }

    componentWillMount() {
       var id_user = this.props.match.params.id;
       this.setState({id: id_user});
       if(id_user)
       {
          this.getUser(id_user);
          this.getDataCash(id_user);
       }
    }

    getUser(id_user){
      var user = AuthService.getCurrentUser();
      ApiService.getUserDetails(user.token,id_user).then(
          (res) => {
              if(res && res.status === 'success')
              {
                  this.setState({ name: res.data.name?res.data.name:'' });
                  this.setState({ last_name: res.data.last_name?res.data.last_name:'' });
              }
          },
          error => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
  }

    getDataCash(id_user){
      var user = AuthService.getCurrentUser();
      this.setState({ loading: true });
      ApiService.getCashUser(user.token,id_user).then(
          (res) => {
              if(res && res.status == 'success'){
                  const items = (res.data || []).map(function(row) {
                    return {
                        Id: row.id,
                        Tipo : row.operation_type,
                        Fecha : row.approval_date,
                        FechaLabel: row.approval_date ? Moment(row.approval_date).format('DD/MM/YYYY') : '—',
                        Detalle : row.detail,
                        Monto : parseFloat(row.amount_cash) || 0,
                        // Quién lo agregó -- Sistema si el movimiento lo generó
                        // el backend solo (compra, ganancia, bono), o el nombre
                        // del admin si fue "Añadir Crédito" desde el panel.
                        AddedBy: row.Admin ? (row.Admin.full_name || row.Admin.email) : 'Sistema',
                    }
                 })
                this.setState({
                    results: items,
                    temp: items,
                    loading: false,
                    page: 1,
                    current_credit: res.user && res.user.Internal_accounts_summary ? res.user.Internal_accounts_summary.amount_cash : 0,
                });
              } else {
                this.setState({ loading: false, results: [], temp: [] });
              }
          },
          error => {
            this.setState({ loading: false, results: [], temp: [] });
          }
        );
  }

    onChangeFilter(e) {
        const val = e.target.value;
        this.setState({ filter: val, page: 1 });

        const needle = val.toLowerCase();
        const rows = this.state.temp.filter(function (row) {
            return ['Tipo', 'Detalle', 'FechaLabel'].some(function (key) {
                return row[key] && row[key].toString().toLowerCase().indexOf(needle) > -1;
            });
        });
        this.setState({ results: rows });
    }

    handleSort(key) {
        this.setState((prev) => ({
            sort: nextSort(prev.sort, key),
            page: 1,
        }));
    }

    clearInputs() {
      this.setState({
          amount: "",
      });
    }

    handleRegister(e) {
        this.setState({
          message: "",
          loading: true
        });

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0 && !this.state.errors.template) {
            this.onCloseModal();
            var user = AuthService.getCurrentUser();
            let data_user = {
              'id_user': this.state.id,
              'cash': this.state.mount,
          }
            ApiService.postCashUser(user.token,data_user).then(
            (res) => {
                if(res && res.status == 'success'){
                  toast.success("Monto agregado!");
                  this.getDataCash(this.state.id);
                  this.clearInputs();
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();

              this.setState({
                loading: false,
                message: resMessage
              });
            }
          );
        } else {
          this.setState({
            loading: false
          });
        }
      }

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

     componentWillReceiveProps(){
        this.getDataCash(this.props.match.params.id);
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 16px', borderTop: '1px solid #f0f0f0', gap: 8,
                background: '#fafafa', fontSize: 13, color: '#666',
            }}>
                <span style={{ fontSize: 12, color: '#aaa' }}>{from}–{to} de {total}</span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === 1 ? '#f4f4f4' : '#fff',
                            color: page === 1 ? '#ccc' : '#333',
                            cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-left' />
                    </button>
                    <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>{page} / {totalPages}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === totalPages ? '#f4f4f4' : '#fff',
                            color: page === totalPages ? '#ccc' : '#333',
                            cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-right' />
                    </button>
                </div>
            </div>
        );
    }

    renderResults() {
        const { results, page, sort, loading } = this.state;
        if (loading) return <div style={{ padding: 16, color: '#888' }}>Cargando...</div>;
        if (results.length === 0) return <div style={{ padding: 16, color: '#888' }}>No hay movimientos de cash para este usuario.</div>;

        const PAGE_SIZE = 50;
        const sorted = sortRows(results, sort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const currentPage = Math.min(page, totalPages);
        const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

        const headers = [
            { label: 'Id', key: 'Id', align: 'left' },
            { label: 'Tipo', key: 'Tipo', align: 'left' },
            { label: 'Fecha', key: 'Fecha', align: 'left' },
            { label: 'Detalle', key: 'Detalle', align: 'left' },
            { label: 'Añadido por', key: 'AddedBy', align: 'left' },
            { label: 'Monto', key: 'Monto', align: 'right' },
        ];

        return (
            <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                {headers.map((h) => (
                                    <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} style={{ textAlign: h.align }} />
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {paginated.map((item) => (
                                <tr
                                    key={item.Id}
                                    style={{ borderBottom: '1px solid #f4f4f4' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f8fbff')}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                                >
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 500, textAlign: 'left' }}>{item.Id}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', textAlign: 'left' }}>{tipoBadge(item.Tipo)}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'left' }}>{item.FechaLabel}</td>
                                    <td style={{ padding: '9px 12px', color: '#666', textAlign: 'left' }}>{item.Detalle}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: item.AddedBy === 'Sistema' ? '#aaa' : '#666', textAlign: 'left' }}>{item.AddedBy}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 700, textAlign: 'right' }}>{fmtMoney(item.Monto)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.renderPagination(sorted.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
            </div>
        );
    }

    render() {
        const { open, current_credit } = this.state;

        const stats = [
            { label: 'Crédito actual', value: fmtMoney(current_credit), icon: 'fa-star', color: '#8e44ad' },
        ];

        return (
            <Fragment>
                <Breadcrumb title={`Historial de movimientos de ${this.state.name+' '+this.state.last_name}`} parent="Digital" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <StatCardsGrid stats={stats} columns={4} />

                            <div className="card" style={{ boxShadow: 'none', border: '1px solid #ebebeb' }}>
                                <div
                                    className="card-header"
                                    style={{
                                        display: 'flex', flexWrap: 'wrap', alignItems: 'center',
                                        justifyContent: 'space-between', gap: 10,
                                    }}
                                >
                                    <h5 style={{ margin: 0 }}>Movimientos de cash</h5>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <input
                                            placeholder="Buscar..."
                                            name="filter"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            onInput={this.onChangeFilter}
                                            style={{
                                                flex: '1 1 180px', minWidth: 140, maxWidth: 260,
                                                height: 32, boxSizing: 'border-box', padding: '4px 10px',
                                            }}
                                        />
                                        <button type="button" className="btn btn-secondary btn-sm" onClick={this.onOpenModal}>
                                            Añadir Crédito
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body" style={{ padding: 0 }}>
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal open={open} onClose={this.onCloseModal}>
                    <div className="modal-header">
                        <h5 className="modal-title f-w-600" id="exampleModalLabel2">Añadir Crédito</h5>
                    </div>
                    <Form
                        id="frmCateg"
                        encType="multipart/form-data"
                        method="POST"
                        ref={c => { this.form = c; }}
                    >
                        <div className="modal-body">
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="col-form-label">Monto :</label>
                                <Input
                                    name="name"
                                    value={this.state.amount}
                                    type="text"
                                    className="form-control"
                                    onChange={this.onChangeMount}
                                    validations={[required]}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={this.state.loading}
                                onClick={() => this.handleRegister()}
                            >
                                {this.state.loading && (
                                    <span className="spinner-border spinner-border-sm"></span>
                                )}
                                <span>Guardar</span>
                            </button>
                            <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal()}>Cancelar</button>
                        </div>
                        {this.state.message && (
                            <div className="form-group">
                                <div className="alert alert-danger" role="alert">
                                    {this.state.message}
                                </div>
                            </div>
                        )}
                        <CheckButton
                            style={{ display: "none" }}
                            ref={c => { this.checkBtn = c; }}
                        />
                    </Form>
                </Modal>
            </Fragment>
        )
    }
}

export default Ver_cash_user
